import React, { useState } from "react"

export default function Header() {

  const [toggleMenuModal, toggleMenuModalFunc] = useState(false);

  return (
    <>
      <div className={toggleMenuModal ? 'modal modal--nav modal--open' : 'modal modal--nav'}>
        <div className="modal-dialogue">

          <button className="modal-btn-close" type="button" onClick={() => toggleMenuModalFunc(!toggleMenuModal)}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>close</title><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" /></svg>
          </button>

          <div className="modal-header">
            <span>Menu</span>
          </div>

          <div className="modal-body">
            <a className="nav-link active" href="/">
              <svg className="svg-home" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>home</title><path d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" /></svg>
              <span>Home</span>
            </a>
            <a className="nav-link" href="/contact">
              <svg className="svg-contact" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>human-greeting-proximity</title><path d="M11 14H9C9 9.03 13.03 5 18 5V7C14.13 7 11 10.13 11 14M18 11V9C15.24 9 13 11.24 13 14H15C15 12.34 16.34 11 18 11M7 4C7 2.89 6.11 2 5 2S3 2.89 3 4 3.89 6 5 6 7 5.11 7 4M11.45 4.5H9.45C9.21 5.92 8 7 6.5 7H3.5C2.67 7 2 7.67 2 8.5V11H8V8.74C9.86 8.15 11.25 6.5 11.45 4.5M19 17C20.11 17 21 16.11 21 15S20.11 13 19 13 17 13.89 17 15 17.89 17 19 17M20.5 18H17.5C16 18 14.79 16.92 14.55 15.5H12.55C12.75 17.5 14.14 19.15 16 19.74V22H22V19.5C22 18.67 21.33 18 20.5 18Z" /></svg>
              <span>Contact</span>
            </a>
            <a className="nav-link" href="/services">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>toolbox-outline</title><path d="M20 8H17V6C17 4.9 16.1 4 15 4H9C7.9 4 7 4.9 7 6V8H4C2.9 8 2 8.9 2 10V20H22V10C22 8.9 21.1 8 20 8M9 6H15V8H9V6M20 18H4V15H6V16H8V15H16V16H18V15H20V18M18 13V12H16V13H8V12H6V13H4V10H20V13H18Z" /></svg>
              <span>Services</span>
            </a>
            <a className="nav-link" href="/gallery">
              <svg className="svg-gallery" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>view-gallery-outline</title><path d="M1 3V21H23V3H1M21 5V14H3V5H21M11 16V19H8V16H11M3 16H6V19H3V16M13 19V16H16V19H13M18 19V16H21V19H18Z" /></svg>
              <span>Gallery</span>
            </a>
            <a className="nav-link" href="/qna">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>chat-question-outline</title><path d="M12 3C6.5 3 2 6.6 2 11C2 13.2 3.1 15.2 4.8 16.5C4.8 17.1 4.4 18.7 2 21C4.4 20.9 6.6 20 8.5 18.5C9.6 18.8 10.8 19 12 19C17.5 19 22 15.4 22 11S17.5 3 12 3M12 17C7.6 17 4 14.3 4 11S7.6 5 12 5 20 7.7 20 11 16.4 17 12 17M12.2 6.5C11.3 6.5 10.6 6.7 10.1 7C9.5 7.4 9.2 8 9.3 8.7H11.3C11.3 8.4 11.4 8.2 11.6 8.1C11.8 8 12 7.9 12.3 7.9C12.6 7.9 12.9 8 13.1 8.2C13.3 8.4 13.4 8.6 13.4 8.9C13.4 9.2 13.3 9.4 13.2 9.6C13 9.8 12.8 10 12.6 10.1C12.1 10.4 11.7 10.7 11.5 10.9C11.1 11.2 11 11.5 11 12H13C13 11.7 13.1 11.5 13.1 11.3C13.2 11.1 13.4 11 13.6 10.8C14.1 10.6 14.4 10.3 14.7 9.9C15 9.5 15.1 9.1 15.1 8.7C15.1 8 14.8 7.4 14.3 7C13.9 6.7 13.1 6.5 12.2 6.5M11 13V15H13V13H11Z" /></svg>
              <span>FAQs</span>
            </a>
            <a className="nav-link" href="/servicearea">
              <svg className="svg-area" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>map-search-outline</title><path d="M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.2 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14A2.5,2.5 0 0,0 13,16.5A2.5,2.5 0 0,0 15.5,19A2.5,2.5 0 0,0 18,16.5A2.5,2.5 0 0,0 15.5,14M19.5,2A0.5,0.5 0 0,1 20,2.5V11.81C19.42,11.26 18.75,10.81 18,10.5V4.7L15,5.86V10C14.3,10.07 13.62,10.24 13,10.5V5.87L9,4.47V16.13H9V16.5C9,17.14 9.09,17.76 9.26,18.34L8,17.9L2.66,19.97L2.5,20A0.5,0.5 0 0,1 2,19.5V4.38C2,4.15 2.15,3.97 2.36,3.9L8,2L14,4.1L19.34,2.03L19.5,2M4,5.46V17.31L7,16.15V4.45L4,5.46Z" /></svg>
              <span>Area</span>
            </a>
          </div>
        </div>
        <div className="modal-wrapper" onClick={() => toggleMenuModalFunc(!toggleMenuModal)}></div>
      </div>

      <div id="png-header">

        <div className="png-header__nav">
          <div className="container">
            <a href="/" className="header-logo-link">
              <img src="/images/EvolutionPHG.png" alt="Logo" />
            </a>
            <div className="gas-safety gas-safety--small">
              <img className="gas-safety__image" src="/images/gas.png" alt="Gas Safety Certificate"/>
            </div>

            <div className="nav-container">

              <div className="nav-link header-mobile-button" onClick={() => toggleMenuModalFunc(!toggleMenuModal)}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>menu</title><path d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" /></svg>
                <span>Menu</span>
              </div>

              <a className="nav-link active" href="/">
                <span>Home</span>
              </a>
              <a className="nav-link" href="/contact">
                <span>Contact</span>
              </a>
              <a className="nav-link" href="/services">
                <span>Services</span>
              </a>
              <a className="nav-link" href="/gallery">
                <span>Gallery</span>
              </a>
              <a className="nav-link" href="/qna">
                <span>FAQs</span>
              </a>
              <a className="nav-link" href="/servicearea">
                <span>Area</span>
              </a>
            </div>

          </div>
        </div>

        <section
          className="png-header__parallax"
          style={{
            backgroundImage:
              "url(/images/1.jpg)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <div className="png-header__parallax__inner">
            <h2>
            {/* <div className="red">Phone: +44 7344 424166</div> */}
            <a className="red" href="tel:+447344424166">07344 424166</a>
            </h2>
            <h1>
              Contact us now, and let us fix your problems!
            </h1>
            <h6>
            Prompt response and quick service delivery.
            </h6>
          </div>
        </section>

      </div>
    </>
  )
}



